import styled from "@emotion/styled";
import React from "react";
import PropTypes from "prop-types";
import Checkbox from '@material-ui/core/Checkbox';
import TranslateTransition from "../animations/TranslateTransition";

const TableRow = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: ${ props => `repeat(${props.columnCount}, 250px)`};
    grid-column-start: 1;
    grid-column-end: 5;
    align-items: center;
    
     &:first-of-type {
        margin-left: ${props => (props.hasIndent) ? "var(--space-s1)" : "0"};
        grid-column-start: 1;
    }
    
    //@media (max-width: 640px){ 
    //      
    //}
    //
    //@media (max-width: 768px){
    //    grid-template-columns: repeat(auto-fill, 150px);
    //}
    //
    //@media (max-width: 1024px){
    //    grid-template-columns: repeat(auto-fill, 150px);
    // }
    //
    //@media (max-width: 1200px){
    //    grid-template-columns: repeat(auto-fill, 150px);
    // }
    //
    //
`;

export const TableCell = styled.span``;

const CustomerRowHeading = styled.h3`
    font-size: var(--font-m);
    color: var(--font-secondary);
    font-weight: 300;
    text-align: center;
    width: fit-content;
    margin: 15px;
`;

export default function TableRowComponent(props) {
    const {tableHeadings, rowData, isSelected, onCheckBoxSelected, hasCheckBox} = props;
    return (
        <>
            {
                <TranslateTransition>
                    <TableRow key="table-row" hasIndent={!hasCheckBox} hasCheckBox={hasCheckBox} columnCount={Object.keys(rowData).length}>

                        {
                            tableHeadings.map((column, index) => {
                                return (index === 0)
                                    ? (
                                        <div key={index} style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                            {
                                                hasCheckBox &&
                                                <Checkbox
                                                    value={rowData.id}
                                                    checked={isSelected}
                                                    onChange={e => onCheckBoxSelected(e, rowData)}
                                                    color="primary"
                                                    inputProps={{
                                                        'aria-label': 'primary checkbox',
                                                    }}
                                                />
                                            }
                                            { React.cloneElement(rowData[column.key], {key: index}) }
                                        </div>
                                    ) :
                                    <span key={index}> {rowData[column.key]} </span>
                            })
                        }


                    </TableRow>
                </TranslateTransition>
            }
        </>
    )
}

TableRowComponent.propTypes = {
    tableHeadings: PropTypes.array,
    rowData: PropTypes.object,
    isSelected: PropTypes.bool,
    hasCheckBox: PropTypes.bool,
    onCheckBoxSelected: PropTypes.func
};
